import { Component } from '@angular/core';
import { LOGIN } from '@core/constants/RoutingsPath';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@core/modules/authentication/services/auth.service';
import { ActivationAccountState } from '@shared/types/activation-account-status';
import { Observable, catchError, of, tap } from 'rxjs';
import { ActiveUser } from '@shared/types/active-user';

@Component({
    selector: 'app-active',
    templateUrl: './active.component.html',
    styleUrls: ['./active.component.scss'],
    standalone: false
})
export class ActiveComponent {
  activeUser$: Observable<ActiveUser | string> = of();

  loginPath = `/${LOGIN}`;
  email: string = '';

  activationState: ActivationAccountState = 'PENDING';

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe((event) => {
      this.activateAccount(event.token);
    });
  }

  onOpenResendVerificationLinkForm() {
    this.showResendVerificationLinkForm();
  }

  onResendVerificationLink(email: string) {
    this.email = email;
    this.showVerifyingEmailUI();
  }

  private activateAccount(activationToken: string) {
    this.activeUser$ = this.authService.activeUser(activationToken).pipe(
      tap((activateUser) => {
        if (activateUser.status === 'token_expired') {
          this.showExpiredLinkUI();
          return;
        }

        this.showAccountActivatedUI();
        setTimeout(() => {
          this.router.navigate([LOGIN]);
        }, 5000);
      }),
      catchError(() => {
        console.error('[ACTIVATE:ACCOUNT] Error activate account. ');

        this.showExpiredLinkUI();

        return of('error');
      })
    );
  }

  private showAccountActivatedUI() {
    this.activationState = 'ACTIVATED';
  }

  private showExpiredLinkUI() {
    this.activationState = 'TOKEN_EXPIRED';
  }

  private showResendVerificationLinkForm() {
    this.activationState = 'RESEND_ACTIVATION_LINK';
  }

  private showVerifyingEmailUI() {
    this.activationState = 'VERIFYING_EMAIL';
  }
}
